import React, { useState, useRef, useEffect } from 'react';
import './App.css';
// markdown parser
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark,atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ReactMarkdown from 'react-markdown';
// Define interface types
interface Message {
  role: 'user' | 'assistant' | 'system';
  text?: string;
  content?: ContentItem[];
  item_id?: string;
}

interface ContentItem {
  type: string;
  transcript?: string;
  audio?: string;
}

interface ServerEvent {
  type: string;
  item?: {
    type: string;
    role: string;
    content: ContentItem[];
  };
  delta?: string;
  item_id?: string;
  transcript?: string;
  error?: {
    message: string;
  };
}

interface ResponseCreateEvent {
  type: string;
  response: {
    modalities: string[];
    voice: string;
    instructions?: string;
  };
}

function CodeExampleBlock({ children, information, ishtml }: { children: string, information: string, ishtml?: boolean }) {

  // hasbeenrun
  const [hasbeenrun, sethasbeenrun] = useState(false);
  const [copybutton, setcopybutton] = useState(false);
  var childrena = children;
  const globals = ["peerConnection", "dataChannel", "ms", "offer", "eventHandlers"];
  for (const global of globals) {
    childrena = childrena.replace(new RegExp("const "+global, "g"), global);
    childrena = childrena.replace(new RegExp("var "+global, "g"), global);
    childrena = childrena.replace(new RegExp(global, "g"), "document."+global);
  }
  childrena = childrena.replace(/console.log/g, "((inp)=>document.querySelector('.outputblock').appendChild(document.createElement('div')).innerText=inp)")
  return (
    <div className="code-block">
    <button className="playbutton bbbuton"
        onClick={() => {
          sethasbeenrun(true);
          if (ishtml) {
            document.querySelector(".outputblock")!.appendChild(document.createElement("div")).innerHTML = childrena;
          }
          else {
            // run the code
            eval(("(async()=>{"+childrena+"})()").replace(".placetoputaudioplayer",".outputblock"));
            }
          }}
        // tickmark emoji if has been run
       disabled={hasbeenrun}>{!hasbeenrun ? "Run" : <span>&#10003;</span>}</button>
       <button className="copybutton bbbuton"
        onClick={() => {
          navigator.clipboard.writeText(childrena);
          setcopybutton(true);
          setTimeout(() => setcopybutton(false), 2000);
        }}>{copybutton ? <span>Copy&#10003;</span> : "Copy"}</button>
      <br></br>
      <div className="minicon">
      {information}



      <pre className="code">
      <SyntaxHighlighter language={
        ishtml ? "html" : "javascript"
      } style={atomDark} showLineNumbers>
        {children}
      </SyntaxHighlighter>
      </pre>
      </div>

    </div>
  );
}

function TypeingBlock({ exampleInputs }:{
  exampleInputs: {
    type: string,
    example: string
  }[]
}) {

  return (

            <div className="code-block">
              <h3>{exampleInputs[0].type}</h3>
              <pre className="code">
                <SyntaxHighlighter language="json" style={atomDark} showLineNumbers>
                  {exampleInputs[0].example}
                </SyntaxHighlighter>
              </pre>
            </div>
          )



}

function App() {

  const [isTyping, setisTyping] = useState(false);
  const [apikey, setapikey] = useState<string|null>(null);
  // path has /dashboard

  const codelots = [
    {
      code: `
const peerConnection = new RTCPeerConnection();
console.log("Peer connection created");`,
      information: `Create a new RTCPeerConnection object.`
    },
    {
      code: `
// create an audio element
const audioEl = document.querySelector(".placetoputaudioplayer");
const dd = document.createElement("audio");
dd.controls = true;
audioEl.appendChild(dd);

peerConnection.ontrack = (e) => {
  // attach the incoming audio stream to the audio element

  const mdata = new MediaStream([e.track]);
  dd.srcObject = mdata;
  dd.play();
};`,
      information: `This will setup and display the incoming audio stream from the connection.`
    },
    {
      code: `
// aquire the user's microphone
const ms = await navigator.mediaDevices.getUserMedia({
  audio: true
});

// add the audio stream to the peer connection
peerConnection.addTrack(ms.getAudioTracks()[0]);

// add visual feedback for audio
const audioContext = new AudioContext();
const analyser = audioContext.createAnalyser();
const source = audioContext.createMediaStreamSource(ms);
source.connect(analyser);
analyser.fftSize = 256;
const bufferLength = analyser.frequencyBinCount;
const dataArray = new Uint8Array(bufferLength);
const canvas = document.createElement("canvas");
const audioEl = document.querySelector(".placetoputaudioplayer");
audioEl.appendChild(canvas);
const canvasCtx = canvas.getContext("2d");
canvas.width = 100;
canvas.height = 100;
canvasCtx.clearRect(0, 0, canvas.width, canvas.height);

function draw() {
  requestAnimationFrame(draw);
  analyser.getByteFrequencyData(dataArray);
  canvasCtx.fillStyle = 'rgb(200, 200, 200)';
  canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
  canvasCtx.fillStyle = 'rgb(0, 0, 0)';
  const barWidth = (canvas.width / bufferLength) * 2.5;
  let barHeight;
  let x = 0;
  for (let i = 0; i < bufferLength; i++) {
    barHeight = dataArray[i];
    canvasCtx.fillRect(x, canvas.height - barHeight / 2, barWidth, barHeight / 2);
    x += barWidth + 1;
  }
}
draw();
`,
      information: `Get the user's audio stream and add it to the RTCPeerConnection.`
    },





    {
      code: `
const dataChannel = peerConnection.createDataChannel("oai-events");

var eventHandlers = {}

dataChannel.onopen = () => {
  console.log("Data channel opened");
}
dataChannel.onerror = (e) => {
  console.log("Data channel error:"+ JSON.stringify(e));
}
dataChannel.onclose = () => {
  console.log("Data channel closed");
}
dataChannel.addEventListener("message", (e) => {
  const data = JSON.parse(e.data);
  const handler = eventHandlers[data.type];
  if (handler) {
    handler(data);
  }
  else
  {
    // check typing for extra message types
  }
});

console.log("Data channel created");
`,
      information: `Create a data channel for sending and receiving events.`
    },
    {
      html: `
      <div style="margin: 16px; display: flex">
        <div class="sessioninformation" style="display: flex; flex-direction: column; border: 1px solid #e0e0e0; border-radius: 8px; padding: 16px;  text-align: left; font-size: 12px; width:50%">
          <h4>Session Information</h4>
          <div class="sessioninfo">
          ... Session Data ...
          </div>
        </div>
        <div class="messages" style="display: flex; flex-direction: column; border: 1px solid #e0e0e0; border-radius: 8px; padding: 16px; text-align: left; font-size: 12px; width:50%">
          <h4>Messages</h4>
          <div class="messagecontent">
          ... Messages ...
          </div>
        </div>
      </div>
      `,
      information: `Create some visual feedback for the data coming from the server.`
    },
    {
      code: `
eventHandlers["session.created"] = (data) => {
  // empty the session information div
  document.querySelector(".sessioninfo").innerHTML = "";
      // for each key in the data object
  for (const key in data.session) {
    // create a div element
    const div = document.createElement("div");
    // set the class of the div to the key
    div.className = "sessioninfo-"+key;
    // set the inner text to the key and value
    div.innerText = key + ": " + data.session[key];
    // append the div to the session information div
    document.querySelector(".sessioninfo").appendChild(div);
  }
}
eventHandlers["conversation.created"] = (data) => {
  console.log("Conversation created");
}
  `
      ,
      information: `Update the session information div with the data from the server.`
    },
    {
      code: `

eventHandlers["conversation.item.created"] = (data) => {
  // create elements for the message
  const message = data.item;
  const div = document.createElement("div");
  div.className = "message";
  const audiocontent = message.content.filter((c) => c.type === "audio");
  const transcriptcontent = message.content.filter((c) => c.transcript);
  const textcontent = message.content.filter((c) => c.type === "text" && !c.transcript);

  const cdiv = document.createElement("div");
  cdiv.innerText = "Role: "+message.role;
  div.appendChild(cdiv);
  // add all audio content from message
  for (const c of audiocontent) {
    const audio = document.createElement("audio");
    audio.src = c.audio;
    audio.controls = true;
    div.appendChild(audio);
  }

  // add all transcript content from message
  for (const c of transcriptcontent) {
    const childdiv = document.createElement("div");
    childdiv.innerText = c.transcript;
    div.appendChild(childdiv);
  }

  // add all text content from message
  for (const c of textcontent) {
    const childdiv = document.createElement("div");
    childdiv.innerText = c.text;
    div.appendChild(childdiv);
  }

  document.querySelector(".messagecontent").appendChild(div);
}`
      ,
      information: `Handle messages from the server.`
    },
    {
      code: `
  const offer = await peerConnection.createOffer();
  await peerConnection.setLocalDescription(offer);
  console.log("Offer created");
      `,
      information: `Create an offer for the connection.`
    },
    {
      code: `
const baseUrl = "https://api.featherless.ai/v1/realtime";
const response = await fetch(\`\${baseUrl}\`, {
  method: "POST",
  headers: {
          'Content-Type': 'application/json',
          'Authorization': \`Bearer ${apikey}\`
        },
        body: JSON.stringify({
          model: 'recursal/QRWKV6-32B-Instruct-Preview-v0.1',
          max_tokens: 100,
          temperature: 0.5,
          voice: 'kak/am_adam',
          turn_detection: {type: "client_vad", threshold: 0.5},
          modalities: ["text", "audio"],
          sdp: offer.sdp
        })
  })
      
if (response.status !== 200) {
    console.log("Error: " + await response.text());
    return;
}
const data = await response.text();

peerConnection.setRemoteDescription(
    {
      type: "answer",
      sdp: data,
    }
  )
      `,
      information: `Send the offer to the Featherless API to establish the connection.`
    }
  ,
  {
    html: `
    <div>
      <button
        class="transcribebutton"
      >Hold to Transcribe</button>
      Transcription:
      <div class="transcription"></div>
      <button
      class="responsebutton"
      >Request response from AI</button>
      Streamed Response:
      <div class="streamedresponse"></div>
    </div>
    `,
    information: `Add some buttons to interact with the server.`
  },
  {
    information: `Add event listeners for transcribe button.`,
    code: `
// press to clear audio buffer on server, release to request transcription
document.querySelector(".transcribebutton").addEventListener("mousedown", () => {
  dataChannel.send(JSON.stringify({type: "input_audio_buffer.clear"}));
  })
document.querySelector(".transcribebutton").addEventListener("mouseup", () => {
  dataChannel.send(JSON.stringify({type: "input_audio_buffer.commit"}));
  })

// response from server with finished transcription
eventHandlers["conversation.item.input_audio_transcription.completed"] = (data) => {
    document.querySelector(".transcription").innerText = data.transcript;
}

// lets user confirm buffer cleared
eventHandlers["input_audio_buffer.cleared"] = (data) => {
  document.querySelector(".transcription").innerText = "Buffer cleared";
}
`},
  {
    information: `Add event listeners for response button.`,
    code: `
document.querySelector(".responsebutton").addEventListener("click", () => {
    dataChannel.send(JSON.stringify({ 
                type: "response.create",
                response: {
                  // you can override any of the session settings here
                }
              }));
  })
eventHandlers["response.text.delta"] = (data) => {
    document.querySelector(".streamedresponse").innerText = data.delta;
  }
`},
]

const typing = [
  `
  {"event_id":"event_d83e398e","type":"session.created","session":{"id":"sess_7665146d","model":"recursal/QRWKV6-32B-Instruct-Preview-v0.1","modalities":["text","audio"],"instructions":"You are a helpful assistant.","voice":"kak/am_adam","input_audio_format":"wav","output_audio_format":"wav","input_audio_transcription":{"model":"whisper-1"},"turn_detection":{"type":"client_vad","threshold":0.5},"tools":[],"tool_choice":"auto","temperature":0.5,"max_response_output_tokens":"inf","client_secret":{"value":"eph_87948b7a","expires_at":1743146178.183}}}
  `,
  `
  {"event_id":"event_1f4a8499","type":"conversation.created","conversation":{"id":"conv_36d25da3","object":"realtime.conversation"}}
  `
  ,
  `
  {"event_id":"event_62a3eefb","type":"conversation.item.created","previous_item_id":null,"item":{"id":"msg_86325ddf","object":"realtime.item","type":"message","status":"completed","role":"system","content":[{"type":"text","text":"You are a helpful assistant."}]}}
  `,
  `
  {"event_id":"event_e80a97c8","type":"input_audio_buffer.cleared"}
  `,
  `
  {"event_id":"event_1813fac1","type":"conversation.item.created","previous_item_id":"msg_86325ddf","item":{"id":"msg_89c27d17","type":"message","role":"user","status":"completed","object":"realtime.item","content":[{"type":"input_audio","audio":"https://realtime-coordinator.featherless.ai/proxy/aHR0cDovLzcyLjUyLjgyLjEwMjo4MDc5L3YxL2F1ZGlvL2F1ZGlvXzgzYjFkZDI3LWJhNmItNGQ1Ni1hOGZjLTc2N2ExNzRiODQ1Yy53YXY=","transcript":"\n   Testing on two three.\n\n"}]}}
  `,
  `
  {"event_id":"event_5604deeb","type":"conversation.item.input_audio_transcription.completed","item_id":"msg_89c27d17","content_index":0,"transcript":"\n   Testing on two three.\n\n"}
  `,
  `
  {"event_id":"event_5e2aa86a","type":"response.created","response":{"id":"resp_121ce0ac","status":"in_progress","output":[],"object":"realtime.response"}}
  `,
  `
  {"event_id":"event_453c57e4","type":"response.output_item.added","response_id":"resp_121ce0ac","output_index":0,"item":{"id":"output_ff29f02e","type":"message","role":"assistant","content":[],"status":"in_progress","object":"realtime.item"}}
  `,
  `
  {"event_id":"event_81215d84","type":"response.content_part.added","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":0,"part":{"type":"text","text":""}}
  `
  ,
  `
  {"event_id":"event_33332535","type":"response.text.done","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":0,"text":""}
  `,
  `
  {"event_id":"event_898b808d","type":"response.text.delta","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":0,"delta":"It "}
  `,
  `
  {"event_id":"event_e8ae3b71","type":"response.content_part.added","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":1,"part":{"type":"audio","audio":"","transcript":""}}
  `
  ,
  `
  {"event_id":"event_6ef3b293","type":"response.transcript.delta","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":1,"delta":"It seems like your input might be incomplete or missing specifics."}
  `,
  `
  {"event_id":"event_abe8e4a8","type":"response.content_part.added","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":2,"part":{"type":"audio","audio":"","transcript":""}}
  `,
  `
  {"event_id":"event_5aeb7e5c","type":"response.audio.done","response_id":"resp_121ce0ac","item_id":"output_ff29f02e","output_index":0,"content_index":1,"audio":""}
  `,
  `
  {"event_id":"event_64f1747e","type":"response.output_item.done","response_id":"resp_121ce0ac","output_index":0,"item":{"id":"output_ff29f02e","type":"message","role":"assistant","content":[{"type":"text","text":"It seems like your input might be incomplete or missing specifics. If you're testing a statement or a concept, could you please provide more information? For example, are you testing a hypothesis, a mathematical statement, or something else? Providing more context will help me give you a more accurate and helpful answer."},{"type":"audio","audio":"https://realtime-coordinator.featherless.ai/proxy/aHR0cDovLzcyLjUyLjgyLjEwMjo4MDc5L3YxL2F1ZGlvL2F1ZGlvXzZjZWI5ZTc5LTNiNzQtNGViNC04ZDgxLWNkZTk0Y2NkYzY4ZC53YXY=","transcript":"It seems like your input might be incomplete or missing specifics.It seems like your input might be incomplete or missing specifics."},{"type":"audio","audio":"https://realtime-coordinator.featherless.ai/proxy/aHR0cDovLzcyLjUyLjgyLjEwMjo4MDc5L3YxL2F1ZGlvL2F1ZGlvX2Q1NDdlOTk0LTQ0ODItNDMxMi04ODVjLTA1NmU0Njg5ZDQ1Yy53YXY=","transcript":" If you're testing a statement or a concept, could you please provide more information? For example, are you testing a hypothesis, a mathematical statement, or something else? Providing more context will help me give you a more accurate and helpful answer. If you're testing a statement or a concept, could you please provide more information? For example, are you testing a hypothesis, a mathematical statement, or something else? Providing more context will help me give you a more accurate and helpful answer."}],"status":"completed","object":"realtime.item"}}
  `
]


  return (
    <div className="App">



      <header>
        <div className="logo">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6L7 12H17L12 18" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <h1>Featherless Realtime API Documentation</h1>
        </div>
      </header>

      <button className="bbbuton"
        onClick={() => {
          setisTyping(!isTyping);
        }}
        style={
          {
          position: "absolute",
          right: "16px",
          top: "16px",
          }
        }
        >{isTyping ? "Show Tutorial" : "Show Typing"}</button>


      <div className="container" style={
        {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          position: "relative",
        }
      }>

        <div style={
          {
            width: "54%",
            display: "flex",
            flexDirection: "column",
          }
        }>

      <div className="code-block">
        <div style={{
          padding:"10px"
        }}>
          <h2>Enter your API key</h2>
          <input type="text" onChange={(e) => setapikey(e.target.value)}></input>
        </div>
      </div>
        {
          codelots.map((codelot, index) => {
            return (
              <CodeExampleBlock key={index} information={codelot.information} ishtml={!!codelot.html}>
                {codelot.code ?? codelot.html}
              </CodeExampleBlock>
            )
          })
        }

        </div>
        {
          isTyping ?
        <div
        style={
          {
          width: "45%",
          // sticky to top
          height: "100vh",
          top: "0"
          }
        }>
        {
          typing.map((example)=>({
            type: JSON.parse(example.replace(/[\n\r]/g, "")).type,
            example: JSON.stringify(JSON.parse(example.replace(/[\n\r]/g, "")), null, 2)
          })).map((example, index) => <TypeingBlock key={index} exampleInputs={[example]} />
          )
        }
        </div>:
        <div style={
          {
            width: "45%",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            // sticky to top
            position: "sticky",
            height: "100vh",
            top: "0",
          }

        }
        className='outputblock'>



        </div>}
      </div>
    </div>
  );
}

export default App;
